<template>
  <AppFaq heading="Vanliga frågor" :data="faqQuestionsAndAnswersMock"></AppFaq>
</template>

<script lang="ts" setup>
import type { FaqQA } from '../AppFaq.vue';
import type AppFaq from '../AppFaq.vue';

const faqQuestionsAndAnswersMock: FaqQA[] = [
  {
    q: 'Hur lång tid tar det innan jag får hem mobilen?',
    a: 'Det beror på vilken modell, färg och minnesstorlek du valt. Du kan alltid se din [orderstatus.](/shop/orderstatus) ',
  },
  {
    q: 'Kan jag delbetala mobilen?',
    a: 'Ja, du kan delbetala din mobil via Klarna. Du kan välja mellan 12, 24 eller 36 månaders delbetalning. Fakturan från Klarna kommer separat och vill du betala av ett större belopp kan du enkelt ändra till önskat högre belopp.',
  },
  {
    q: 'Hur och när kan jag avbryta min order?',
    a: 'Du kan avbryta din order dagen efter eller inom 14 dagar, utan kostnad. Har du avbrutit din order och ett simkort redan är utskickat till dig, behöver du inte att skicka kortet tillbaka. Om du har beställt med en mobil eller annat tillbehör behöver du skicka tillbaka det och du står för returkostnaden.',
  },
];
</script>

<style></style>
